//react-components
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { withRouter } from "react-router";

// Components
import Header from "./Header";

// Utils
import { APPLICATION_CONFIGURATIONS } from "../Utils/ApplicationConfigurations";

// Constants
import {
  HTTP,
  API_RESPONSE_STATUS_CODES,
} from "../Utils/Constants";

// Actions
import { logoutAction } from "../Login/LoginAction";
import { getProfileAction } from "./HeaderAction";
import { getProfilePhotoAction } from "../AddOrUpdateUser/AddOrUpdateUserAction";
import { saveUserDetailsAction } from "../UserList/UserListAction";

//Styles
import "./Header.scss";

class HeaderContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      profilePicUrl: null,
    };
  }

  /**
   * handles branch name selection change and calls action to save selected branch name in reducer
   */

  /**
   * Handling the logout  TODO:This has been handled with router which need to be changed
   */
  handleLogout = () => {
    this.props.logoutAction((response) => {
      if (response.status === HTTP.OK) {
        this.props.history.push(APPLICATION_CONFIGURATIONS.path.login);
      }
    });
  };
  /**
   * handles profile and calls action to save selected profile in reducer
   */
  handleProfile = () => {
    getProfileAction(
      this.props.loginReducer.userName,
      (responseStatus, responseData) => {
        if (responseStatus === API_RESPONSE_STATUS_CODES.SUCCESS) {
          this.props.saveUserDetailsAction(responseData.data);
          this.props.history.replace(
            APPLICATION_CONFIGURATIONS.path.profileDetails
          );
        }
      }
    );
  };
  /**
   * Handling the Change Password
   */
  handleChangePassword = () => {
    this.props.history.push(APPLICATION_CONFIGURATIONS.path.changePassword);
  };

  //Callback to handle get profile pic
  getProfilePhoto = (userId) => {
    getProfilePhotoAction(userId, (responseData) => {
      if (responseData?.status === API_RESPONSE_STATUS_CODES.SUCCESS) {
        this.setState({
          errorMessage: "",
        });
        this.setState({ profilePicUrl: responseData.data.s3Url });
      } else {
        this.setState({ profilePicUrl: null });
      }
    });
  };

  render() {
    return (
      <Header
        handleProfile={this.handleProfile}
        handleLogout={this.handleLogout}
        handleChangePassword={this.handleChangePassword}
        loggedInUserData={this.props.loginReducer}
        branches={this.props.HeaderReducer.branches}
        selectedBranchId={this.props.HeaderReducer.branchId}
        getProfilePhoto={this.getProfilePhoto}
        profilePicUrl={this.state.profilePicUrl}
      />
    );
  }
}

function matchDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      getProfileAction: getProfileAction,
      logoutAction: logoutAction,
      saveUserDetailsAction: saveUserDetailsAction,
      getProfilePhotoAction: getProfilePhotoAction,
    },
    dispatch
  );
}

function mapStateToProps(state) {
  return {
    loginReducer: state.loginReducer,
    HeaderReducer: state.HeaderReducer,
  };
}

export default withRouter(
  connect(mapStateToProps, matchDispatchToProps)(HeaderContainer)
);
